export default { // Screens Names Provided By Triskele
  dashboard: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Client Dashboard (Clinician View)'
  },
  calendar: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Client Dashboard Calendar to Select New Period'
  },
  recommendation: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Clinician Recommendations'
  },
  profileHeader: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Clinician',
    ScreenName: 'Client Profile'
  },
  master: {
    ScreenId: '1_PPrDdDd01',
    Application: 'Prism - Master',
    ScreenName: 'Master'
  }
};
